import { SERVER_API_URL } from "../app.constants";
import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { ActivityRegistrationInfoDto } from "../activities/daily-activities/day-activities.component";
import * as dataCore from "../core/datacore";
import { ClearActivitiesDto } from "../activities/clear-activities.component";

@Injectable()
export class ActivityService {
    private resourceUrl = SERVER_API_URL + 'api/activities';

    constructor(
        private http: HttpClient) {
    }

    getActivities(day: Date): Observable<HttpResponse<Nema.Crew.Model.Activity[]>> {
        return this.http
            .get<Nema.Crew.Model.Activity[]>(`${this.resourceUrl}?day=${day.toISOString()}`, { observe: 'response' })
            .map((res: HttpResponse<Nema.Crew.Model.Activity[]>) => this.convertArrayResponse(res));
    }

    getActivitiesByWorkplace(day: Date): Observable<HttpResponse<WorkplaceActivityDto[]>> {
        return this.http
            .get<WorkplaceActivityDto[]>(`${this.resourceUrl}/by-workplace?day=${day.toISOString()}`, { observe: 'response' })
            .map((res: HttpResponse<WorkplaceActivityDto[]>) => this.convertArrayResponse2(res));
    }

    updateActivity(activity: Nema.Crew.Model.Activity): Observable<HttpResponse<boolean>> {
        return this.http
            .put(`${this.resourceUrl}/${activity.Id}`, activity, { observe: 'response' })
            .map((res: HttpResponse<boolean>) => res);
    }

    deleteActivity(activityId: number): Observable<HttpResponse<boolean>> {
        return this.http
            .delete(`${this.resourceUrl}/${activityId}`, { observe: 'response' })
            .map((res: HttpResponse<boolean>) => res);
    }

    deleteAllDayActivities(day: Date): Observable<HttpResponse<boolean>> {
        return this.http
            .delete(`${this.resourceUrl}?day=${day.toISOString()}`, { observe: 'response' })
            .map((res: HttpResponse<boolean>) => res);
    }

    registerActivities(activityRegistrationInfo: ActivityRegistrationInfoDto): Observable<HttpResponse<boolean>> {
        const day = dataCore.getStartOfDay(activityRegistrationInfo.selectedDay);
        return this.http
            .post(`${this.resourceUrl}?day=${day.toISOString()}`, activityRegistrationInfo, { observe: 'response' })
            .map((res: HttpResponse<boolean>) => res);
    }

    clearActivities(clearActivitiesDto: ClearActivitiesDto): Observable<HttpResponse<boolean>> {
        return this.http
            .post<boolean>(`${this.resourceUrl}/clear-activities`, clearActivitiesDto, { observe: 'response' })
    }

    getActivityStartForWorkplace(workplaceId: number): Observable<HttpResponse<YearAndMonth>> {
        return this.http
            .get<YearAndMonth>(`${this.resourceUrl}/activity-start`, { observe: 'response', params: { 'wid': `${workplaceId}` } });
    }

    getPersonActivitySchedules(personActivitySchedulesInputDto: PersonActivityScheduleParameters) {
        return this.http
            .post<PersonActivitySchedule[]>(`${this.resourceUrl}/person-activity-schedules`, { ...personActivitySchedulesInputDto, Month: personActivitySchedulesInputDto.Month + 1 }, { observe: 'response' });
    }

    //private _convertResponse(res: HttpResponse<ActivityDto>): HttpResponse<ActivityDto> {
    //    const body: ActivityDto = this.convertItemFromServer(res.body);
    //    return res.clone({ body });
    //}

    private convertArrayResponse(res: HttpResponse<Nema.Crew.Model.Activity[]>): HttpResponse<Nema.Crew.Model.Activity[]> {
        const jsonResponse: Nema.Crew.Model.Activity[] = res.body;
        const body: Nema.Crew.Model.Activity[] = [];
        for (let i = 0; i < jsonResponse.length; i++) {
            body.push(this.convertItemFromServer(jsonResponse[i]));
        }

        return res.clone({ body });
    }

    private convertItemFromServer(activity: Nema.Crew.Model.Activity): Nema.Crew.Model.Activity {
        const copy: Nema.Crew.Model.Activity = Object.assign({}, activity);
        return copy;
    }

    private convertArrayResponse2(res: HttpResponse<WorkplaceActivityDto[]>): HttpResponse<WorkplaceActivityDto[]> {
        const jsonResponse: WorkplaceActivityDto[] = res.body;
        const body: WorkplaceActivityDto[] = [];
        for (let i = 0; i < jsonResponse.length; i++) {
            body.push(this.convertItemFromServer2(jsonResponse[i]));
        }

        return res.clone({ body });
    }

    private convertItemFromServer2(activity: WorkplaceActivityDto): WorkplaceActivityDto {
        const copy: WorkplaceActivityDto = Object.assign({}, activity);
        return copy;
    }
}

export interface WorkplaceActivityDto {
    Workplace: Nema.Crew.Model.Workplace;
    Activities: Nema.Crew.Model.Activity[];
}

export interface ActivityTypeInfo {
    ActivityTypeName: string;
    ActivityTypeTimeNorm: number;
    ActivityTypeColor: string;
}

export interface YearAndMonth {
    Year: number;
    Month: number;
}

export interface PersonActivityScheduleParameters {
    WorkplaceId: number;
    Year: number;
    Month: number;
    ShowBalance: boolean;
    ShowCrossWorkplaceBalance: boolean;
}

export interface PersonActivitySchedule {
    PersonId: number;
    PersonName: string;
    WorkGroupIds: number[];
    JobTypes: string; // Comma separated list
    TimeBalance: TimeBalance;
    ActivitySchedule: ActivityTypeInfoWithRemark[];
}

export interface TimeBalance {
    Primo: number;
    On: number;
    Off: number;
    Total: number;
}

export interface ActivityTypeInfoWithRemark {
    ActivityTypeInfo: ActivityTypeInfo;
    Remark: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/services/activity.service.ts